import { CardPaymentRedirectEffects } from './card.payment.redirect.effect';
import { CreateOrderEffects } from './create.order.effect';
import { DirectDebitEffects } from './direct.debit.effect';
import { UpfrontPaymentEffects } from './upfront.payment.effect';

export const CompleteOrderEffects = [
  DirectDebitEffects,
  CreateOrderEffects,
  CardPaymentRedirectEffects,
  UpfrontPaymentEffects,
];

export * from './direct.debit.effect';
export * from './create.order.effect';
export * from './card.payment.redirect.effect';
export * from './upfront.payment.effect';
